import DeleteIcon from "@mui/icons-material/Delete"
import { Box, CircularProgress, DialogContentText, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { useAppDispatch } from "hooks"
import { useState } from "react"
import userGroupService from "services/userGroupService"
import { removeUserGroup } from "slices/userGroupSlice"
import type { IUserGroup } from "types/userGroupTypes"

type Props = {
  userGroup: IUserGroup
}

export function DeleteUserGroupDialog({ userGroup }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [open, setOpen] = useState(false)

  const dispatch = useAppDispatch()

  const handleClickDeleteUserGroup = () => {
    setIsLoading(true)

    userGroupService
      .deleteUserGroup(userGroup.id)
      .then((_resp) => {
        dispatch(removeUserGroup(userGroup))
        setIsLoading(false)
        handleClose()
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <DeleteIcon sx={{ marginRight: 1 }} />
        Delete
      </MenuItem>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{`Delete ${userGroup.name}`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Are you sure you want to delete ${userGroup.name} user group?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Box sx={{ m: 1, position: "relative" }}>
            <Button onClick={handleClickDeleteUserGroup} disabled={isLoading}>
              Delete
            </Button>
            {isLoading && (
              <CircularProgress
                size={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  )
}
